// Словарь интерфейса: zh
const zh = {
  "home": {
    "title": "首页",
    "description": "这是我们网站的首页。",
    "branches": "分部",
    "invoices": "账单",
    "warehouse": "仓库",
    "bonuses": "奖励",
    "terms": "条款",
    "contacts": "联系方式",
    "parcels": "包裹",
    "account": "账户",
    "calculator": "运费计算",
    "dashboard": "控制面板",
    "banner": "横幅"
  },
  "about": {
    "title": "关于我们",
    "description": "了解更多关于我们公司的信息。"
  },
  "contact": {
    "title": "联系方式",
    "description": "在此与我们联系。"
  },
  "menu": {
    "instruction": "使用说明",
    "branches": "分部",
    "warehouseAddress": "仓库地址",
    "lostItems": "遗失物品",
    "contacts": "联系方式",
    "copy": "复制",
    "aboutUs": "关于我们",
    "prohibitedItems": "禁止订购的商品",
    "home": "首页",
    "parcels": "包裹",
    "profile": "我的",
    "myParcels": "我的包裹",
    "addTrack": "添加单号",
    "archive": "归档",
    "allParcels": "全部包裹",
    "settings": "设置",
    "username": "客户代码（与收货地址中一致）",
    "saveUsername": "保存",
    "currentPassword": "当前密码",
    "newPassword": "新密码",
    "changePassword": "修改密码",
    "close": "关闭",
    "dashboard": "控制面板",
    "logout": "退出",
    "about": "说明",
    "moreTrack": "全部包裹",
    "passwd": "密码",
    "notifications": "通知"
  },
  "common": {
    "loading": "加载中...",
    "back": "返回",
    "cancel": "取消",
    "save": "保存",
    "delete": "删除",
    "edit": "编辑",
    "all": "全部",
    "archive": "归档",
    "next": "下一页",
    "prev": "上一页",
    "page": "第 {{page}} / {{total}} 页",
    "none": "—"
  },
  "account": {
    "title": "账户",
    "name": "姓名：",
    "phone": "电话：",
    "username": "Username：",
    "branch": "分部：",
    "notSet": "未设置",
    "password": "密码",
    "changePassword": "修改密码",
    "logout": "退出账户",
    "loadFail": "无法加载个人资料。",
    "theme": "主题",
    "themeAuto": "自动",
    "themeLight": "浅色",
    "themeDark": "深色",
    "language": "语言",
    "accent": "配色",
    "accentGreen": "经典",
    "accentRed": "红色（与应用一致）",
    "accentBlue": "蓝色",
    "accentPurple": "紫色",
    "accentOrange": "橙色",
    "accentTeal": "青色",
    "accentPink": "粉色"
  },
  "parcels": {
    "title": "我的包裹",
    "addTitle": "添加包裹",
    "trackPh": "请输入快递单号",
    "descPh": "备注（例如：Zara 夹克）",
    "fillAll": "请填写所有字段",
    "notAuth": "用户未登录",
    "added": "已添加收藏",
    "addError": "添加包裹失败",
    "archiveAll": "归档所有已签收",
    "archiveCount": "归档 {{count}} 个单号？",
    "archiveBtn": "归档",
    "toArchive": "归档",
    "archiveOne": "移入归档？",
    "archived": "已归档 {{done}} / {{total}} 个单号",
    "archivedOne": "已移入归档",
    "noIssued": "没有已签收的单号",
    "deleteQ": "删除此收藏？",
    "deleted": "收藏已删除",
    "saved": "收藏已保存",
    "noBookmarks": "暂无收藏",
    "noHistory": "暂无记录",
    "showFull": "显示完整记录",
    "collapse": "收起记录",
    "editTitle": "编辑收藏",
    "trackNumber": "快递单号",
    "description": "备注",
    "errArchive": "归档失败",
    "errLoad": "获取收藏失败",
    "errDelete": "删除收藏失败",
    "errSave": "保存收藏失败",
    "archiveAllTitle": "归档所有单号",
    "archiveOneTitle": "归档"
  },
  "auth": {
    "loginTitle": "登录系统",
    "loginSubtitle": "请输入手机号和密码",
    "login": "登录",
    "noAccount": "没有账户？立即注册",
    "forgot": "忘记密码？",
    "offer": "公开要约",
    "regTitle": "注册",
    "name": "名",
    "surname": "姓（选填）",
    "usernamePh": "客户代码——与地址中一致",
    "codeHint": "客户代码由您所在分店的代表通过私信提供。",
    "invitedBranch": "分店：{{name}}",
    "referrerPh": "推荐人手机号（选填）",
    "inviteNotice": "注册需要客户代码，由您所在分店的代表通过私信提供。请输入代码以及收到该代码的手机号。",
    "chooseBranch": "选择分部",
    "passwordPh": "设置密码",
    "agree": "我同意个人数据处理，并接受",
    "terms": "条款",
    "register": "注册"
  },
  "status": {
    "expected": "待到货",
    "arrivedWarehouse": "已到仓库",
    "sent": "已发货",
    "arrivedBranch": "已达分部",
    "arrivedAlmaty": "已到阿拉木图",
    "issued": "已签收",
    "ready": "可取货",
    "inTransit": "运输中",
    "unknown": "未知"
  }
};

export default zh;
